module.exports = __webpack_public_path__ + "img/view-sequential-blk.25cb5e45.svg";